<template>
  <div>
    <div class="banner">
      <div class="LOGO">
        <div class="LOGO-title">企业名录</div>
        <img class="LOGO-img" :src="require('@/assets/recycling/componyImages/bgLogo.png')" alt="">
      </div>
    </div>
    <component-info
        class="Details"
        @backTopHome="showCardInfo = false"
        v-if="showCardInfo"
        :componentInfo="componentInfoMation"
    ></component-info>
    <div v-else class="company-showcase">
      <!-- 筛选头部 -->
      <div class="filter-header">
        <div class="filter-header-box">
          <!--          <h1 class="page-title">再生资源企业名录</h1>-->
          <el-button
              type="primary"
              size="small"
              v-if="$store.state.ordinaryLoggedIn"
              @click="showAddDialog"
              style="margin-left: 20px;font-size: 16px"
          >
            <i class="el-icon-plus"></i> 申请入驻
          </el-button>
        </div>
        <div class="filter-controls">
          <div class="filter-group">
            <label class="filter-label">业务类型</label>
            <div class="filter-options">
              <button
                  v-for="type in businessTypes"
                  :key="type.value"
                  class="filter-button"
                  :class="{ active: activeBusinessType === type.value }"
                  @click="choseType(type.value)"
              >
                {{ type.label }}
              </button>
            </div>
          </div>
          <div class="filter-group">
            <label class="filter-label">企业级别</label>
            <div class="filter-options">
              <button
                  v-for="type in levelType"
                  :key="type.value"
                  class="filter-button"
                  :class="{ active: activeLevelType === type.value }"
                  @click="choselevelType(type.value)"
              >
                {{ type.label }}
              </button>
            </div>
          </div>
          <div class="filter-group">
            <label class="filter-label">所在地区</label>
            <div class="address-filters">
              <select
                  @change="choseCity"
                  v-model="selectedCity"
                  class="address-select"
              >
                <option value="">全部城市</option>
                <option
                    v-for="city in cities"
                    :key="city.adcode"
                    :label="city.name"
                    :value="city.adcode"
                ></option>
              </select>

              <select
                  v-model="selectedDistrict"
                  class="address-select"
                  @change="choseDistricts"
                  :disabled="!selectedCity"
                  :key="'district-select-' + selectedCity"
              >
                <option value="">全部区域</option>
                <option
                    v-for="district in filteredDistricts"
                    :key="district.adcode"
                    :label="district.name"
                    :value="district.adcode"
                ></option>
              </select>
            </div>
          </div>
          <div class="filter-group">
            <label class="filter-label">企业名称</label>
            <div class="address-filters">
              <el-input
                  placeholder="请输入内容"
                  @keyup.enter.native="componySearch"
                  v-model="componyName"
                  class="input-with-select"
              >
                <el-button
                    @click="componySearch"
                    slot="append"
                    icon="el-icon-search"
                ></el-button>
              </el-input>
              <el-button style="font-size: 16px" @click="resetFilters">重 置</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="company-grid">
        <mini-card
            v-for="(company, index) in companiesfilter"
            :key="index"
            :company="company"
            @card-click="handleCardClick"
        />
      </div>
      <div class="pagination" v-if="companiesfilter.length">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[15, 30, 45, 60]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
      <!-- 空状态 -->
      <div v-if="!companiesfilter.length" class="empty-state">
        <img
            src="../../assets/recycling/index/empty.svg"
            alt="没有找到企业"
            class="empty-image"
        />
        <h3 class="empty-title">没有找到匹配的企业</h3>
        <p class="empty-message">尝试调整筛选条件或重置筛选</p>
        <button class="reset-button" @click="resetFilters">重置筛选</button>
      </div>
    </div>
    <!-- 新增企业对话框 -->
    <add-company-dialog
        :visible.sync="dialogVisible"
        @refresh="getCompanies"
    />
    <bottom-url class="bottomUrl"/>
  </div>
</template>

<script>
import miniCard from '@/views/IndustrialEcology/component/miniCard.vue';
import sichuanAdcode from '@/util/sichuanAdcode.json';
import BottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import componentInfo from '@/views/IndustrialEcology/component/componentInfo.vue';
import {scrollTop} from '@/util/scrollTop';
import {getComponyList} from '@/API/compony/compony'
import AddCompanyDialog from './component/AddCompanyDialog.vue'
import {MaplibreGLMap} from '@/plugins/mapjs/mapConfig';

export default {
  components: {
    BottomUrl,
    miniCard,
    componentInfo,
    AddCompanyDialog
  },
  data() {
    return {
      dialogVisible: false,
      componyName: '',
      componentInfoMation: '',
      showCardInfo: false,
      pageNum: 1,
      pageSize: 15,
      total: 0,
      // 筛选数据
      activeBusinessType: 'all',
      activeLevelType: 'all',
      selectedCity: '',
      selectedDistrict: '',
      cityCode: '',
      filteredDistricts: [],
      // 业务类型选项
      businessTypes: [
        {value: 'all', label: '全部'},
        {value: 'recycleStation', label: '回收网点'},
        {value: 'transferStation', label: '中转站'},
        {value: 'sortingCenter', label: '分拣中心'},
        {value: 'wasteEnterprise', label: '利废企业'},
        {value: 'dismantlingCenter', label: '二手交易市场'},
        {value: 'industrialPark', label: '产业园区/集散市场'},
        {value: 'other', label: '其他'},
      ],
      levelType: [
        {value: 'all', label: '全部'},
        {value: 0, label: '普通企业'},
        {value: 1, label: '重点企业'},
      ],
      // 城市和区域数据
      cities: [],
      districts: [],
      // 模拟的公司数据
      companiesfilter: [],
      companies: [
        // {
        //   name: '四川浩睿永多再生物资回收有限公司',
        //   image: require('@/assets/recycling/componyImages/sean-pollock-PhYq704ffdA-unsplash.jpg'),
        //   types: ['利废企业'],
        //   address: '成都市青羊区蛟龙工业港',
        //   phone: '010-98765432',
        //   rating: 4.6,
        //   description:
        //     '专注于废弃物资源化利用的高新技术企业，拥有多项专利技术。',
        //   businessType: ['utilization'],
        //   city: '510100',
        //   district: '510117',
        // },
      ],
    };
  },
  watch: {
    '$store.state.routerClickStatus': {
      handler: function (val) {
        this.moveHome()
      },
    },
  },
  mounted() {
    this.cities = sichuanAdcode;
    this.filteredDistricts = sichuanAdcode[0].districts;
    this.companiesfilter = this.companies;
    
    // 新增：检查是否有从全局搜索跳转过来的关键词
    const globalKeyword = sessionStorage.getItem('search_keyword_from_global');
    if (globalKeyword) {
      this.componyName = globalKeyword;
      sessionStorage.removeItem('search_keyword_from_global');
      // 触发搜索
      this.componySearch();
    } else {
      // 原有逻辑
      this.getCompanies();
    }

    if (this.$route.params.isValue) {
      this.activeBusinessType = 'wasteEnterprise'
    }
  },
  methods: {
    showAddDialog() {
      this.dialogVisible = true
    },
    // 获取数据
    getCompanies() {
      let parmrs = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        businessType: this.activeBusinessType === 'all' ? '' : this.activeBusinessType,
        levelType: this.activeLevelType === 'all' ? '' : this.activeLevelType,
        keywords: this.componyName,
        adcode: this.cityCode
      }
      getComponyList(parmrs).then(res => {
        if (res.code === 200) {
          this.companies = res.data.records
          this.companiesfilter = res.data.records
          this.total = res.data.total
        }
      })
    },
    handleCardClick(company) {
      this.componentInfoMation = company;
      this.showCardInfo = true;
      // 这里可以跳转到详情页
    },
    //重置过滤条件
    resetFilters() {
      this.activeBusinessType = 'all';
      this.selectedCity = '';
      this.selectedDistrict = '';
      this.componyName = '';
      this.cityCode = ''
      this.getCompanies()
    },
    // 业务类型
    choseType(activeBusinessType) {
      console.log(activeBusinessType, 'activeBusinessType');
      this.pageNum = 1
      this.activeBusinessType = activeBusinessType;
      this.getCompanies()
    },
    // 企业级别
    choselevelType(activeLevelType) {
      console.log(activeLevelType, 'activeLevelType');
      this.pageNum = 1
      this.activeLevelType = activeLevelType;
      this.getCompanies()
    },
    //城市选择
    choseCity() {
      sichuanAdcode.map(item => {
        if (item.adcode == this.cityCode) {
          this.filteredDistricts = JSON.parse(JSON.stringify(item.districts))
        }
      })
      this.pageNum = 1
      this.cityCode = this.selectedCity;
      this.getCompanies()// 重置选中的区域
      this.selectedDistrict = '';

      // 确保响应式更新
      const selectedCityObj = sichuanAdcode.find(item => item.adcode == this.selectedCity);
      this.filteredDistricts = selectedCityObj ? [...selectedCityObj.districts] : [];

      this.pageNum = 1;
      this.cityCode = this.selectedCity;
      this.getCompanies();

    },
    // 地区选择
    choseDistricts() {
      this.pageNum = 1
      this.cityCode = this.selectedDistrict;
      this.getCompanies()
    },
    // 企业搜索
    componySearch() {
      this.pageNum = 1
      this.getCompanies()
    },
    moveHome() {
      this.showCardInfo = false;
      scrollTop();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCompanies()
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCompanies()
    }
  },
};
</script>

<style lang="less" scoped>
.Details {
  margin-top: 50px;
}

.company-showcase {
  max-width: 1400px;
  margin: 0 auto;
  //padding: 24px;
  font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.banner {
  display: flex;
  justify-content: center;
}

.LOGO {
  width: 1400px;
  height: 320px;
  position: relative;

  .LOGO-img {
    position: absolute;
    left: 0;
    top: 0;
    width: inherit;
    height: inherit;
  }

  .LOGO-title {
    position: absolute;
    text-align: center;
    font-size: 40px;
    font-weight: 400;
    left: 5%;
    top: 12%;
    z-index: 9;
  }
}

/* 头部样式 */
.filter-header {
  background-color: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  .filter-header-box {
    display: flex;
    justify-content: end;
    margin-bottom: 20px;

    /deep/ .el-button--primary {
      background-color: #1ABE6B;
      border-color: #1ABE6B;
    }

    /deep/ .el-button--primary:hover {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.page-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 24px;
  background-color: #4caf50;
  margin-right: 12px;
  border-radius: 2px;
}

.filter-controls {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  font-size: 16px;
  font-weight: 500;
  color: #666;
}

.filter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-button {
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  color: #666;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-button:hover {
  background-color: #e0e0e0;
}

.filter-button.active {
  background-color: #1abe6b;
  color: white;
  border-color: #1abe6b;
}

.el-button:focus,
.el-button:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.address-filters {
  display: flex;
  gap: 12px;
}

.address-select {
  flex: 1;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.address-select:focus {
  outline: none;
  border-color: #409eff;
}

/* 公司网格布局 */
.company-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
}

.pagination {
  display: flex;
  justify-content: end;
  width: 100%;
  margin-top: 20px;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  text-align: center;
}

.empty-image {
  width: 200px;
  height: 200px;
  margin-bottom: 24px;
  opacity: 0.6;
}

.empty-title {
  margin: 0 0 12px 0;
  font-size: 20px;
  color: #666;
}

.empty-message {
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #999;
}

.reset-button {
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  background-color: #4caf50;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-button:hover {
  background-color: #3d8b40;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .LOGO {
    width: 100% !important;
    height: 120px !important;
  }

  .LOGO-title {
    font-size: 18px !important;
    font-weight: bold !important;
  }

  .company-showcase {
    max-width: 100% !important;

    .filter-header {
      padding: 10px !important;
    }
  }
  .filter-label {
    font-size: 16px !important;
  }
  .filter-group {
    gap: 10px !important;

    .filter-label {
      font-weight: bold !important;
      padding: 10px 0 0 0 !important;
    }
  }

  .company-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .company-card {
    max-width: 100% !important;
  }

  .address-filters {
    flex-direction: column;
  }

  .address-select {
    padding: 10px 12px !important;
    font-size: 14px !important;
  }
  .filter-options {
    gap: 6px;
  }

  .filter-button {
    padding: 6px 12px;
    font-size: 13px;
  }

  .pagination {
    justify-content: center !important;
  }

  /deep/ .el-pagination span:not([class*=suffix]) {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .LOGO {
    width: 100% !important;
    height: 120px !important;
  }

  .LOGO-title {
    font-size: 18px !important;
    font-weight: bold !important;
  }

  .company-showcase {
    max-width: 100% !important;

    .filter-header {
      padding: 10px !important;
    }
  }

  .filter-group {
    gap: 10px !important;

    .filter-label {
      font-weight: bold !important;
      padding: 10px 0 0 0 !important;
    }
  }

  .company-card {
    max-width: 100% !important;
  }

  .filter-header {
    padding: 16px;
  }

  .page-title {
    font-size: 24px;
  }
  .pagination {
    justify-content: center !important;
  }

  /deep/ .el-pagination span:not([class*=suffix]) {
    display: none !important;
  }
}

.bottomUrl {
  margin-top: 60px;
}
</style>
